<script setup lang="ts">
import { AlphabetTabsProps } from "~/components/Pages/Wiki/AlphabetTabs.props"
import { SeoBaseProps } from "~/components/seo/Base.props"
import { customPaths } from "~/utils/constants"

const route = useRoute()
const { t, locale } = useI18n()

const { data, error } = await usePage(
  `/api/gluon/fetchWikiCategoryPage/${locale.value}/${
    route.params.category as string
  }/wiki_category.js`
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

const alphabetTabsData = computed((): AlphabetTabsProps | undefined => {
  const pageInfo = data?.value?.page

  if (!pageInfo) return undefined
  return {
    category: pageInfo?.category,
    breadcrumbs: {
      currentPage: pageInfo?.category.name,
      links: [
        {
          label: t("breadcrumbs.home"),
          to: "/"
        },
        {
          label: t("breadcrumbs.wikiHome"),
          to: customPaths.wikiRoot
        }
      ]
    }
  }
})

const seoData = computed((): SeoBaseProps => {
  return {
    ...data.value?.seo,
    metaTitle:
      `${data.value?.seo.metaTitle} - Pagina ${route.params.page}` ||
      `${alphabetTabsData.value?.category.name} - Pagina ${route.params.page}`
  }
})
</script>

<template>
  <div>
    <SeoBase v-if="seoData" v-bind="seoData" />
    <PagesWikiAlphabetTabs
      v-if="alphabetTabsData"
      v-bind="alphabetTabsData"
      :letter="route.query?.letter as string"
    />
  </div>
</template>
